/**
 * FNV-1a hash over the raw IEEE-754 bits of a number sequence.
 * Used to fingerprint sim state for determinism tests and replay verification.
 */
const buf = new ArrayBuffer(8);
const f64 = new Float64Array(buf);
const u32 = new Uint32Array(buf);

export class StateHasher {
  private h = 0x811c9dc5;

  private mixU32(v: number): void {
    let h = this.h;
    for (let i = 0; i < 4; i++) {
      h ^= (v >>> (i * 8)) & 0xff;
      h = Math.imul(h, 0x01000193) >>> 0;
    }
    this.h = h;
  }

  addNumber(v: number): this {
    f64[0] = v;
    // Uint32Array views over a fresh ArrayBuffer are index-safe here; the
    // non-null assertions are guarded by the fixed 8-byte buffer above.
    this.mixU32(u32[0] as number);
    this.mixU32(u32[1] as number);
    return this;
  }

  addInt(v: number): this {
    this.mixU32(v | 0);
    return this;
  }

  digest(): number {
    return this.h >>> 0;
  }
}

export function hashNumbers(values: readonly number[]): number {
  const h = new StateHasher();
  for (const v of values) h.addNumber(v);
  return h.digest();
}
